import { useQuery } from '@tanstack/react-query';

import { BalanceHistoryApi } from '../../apis';
import { QueryKeys } from '../query-keys';

const useBalanceHistory = () => {
  const query = useQuery({
    queryKey: [QueryKeys.BALANCE_HISTORY],
    queryFn: () => BalanceHistoryApi.get(),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    balances: query.data?.balances || [],
  };
};

export default useBalanceHistory;
